var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  viewBox: "0 0 30 30"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#528AEA",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fillOpacity: .295,
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.322 9.952l-1.274-1.274L15 13.727 9.952 8.678 8.678 9.952 13.727 15l-5.049 5.048 1.274 1.274L15 16.273l5.048 5.049 1.274-1.274L16.273 15z"
}))));
export default __webpack_public_path__ + "teg/media/close-circle.5da9f18d.svg";
export { SvgComponent as ReactComponent };